module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/crm/leads/leads.html
// module id = 411
// module chunks = 0